import { render, staticRenderFns } from "./Plans.vue?vue&type=template&id=f61c1732&scoped=true"
import script from "./Plans.vue?vue&type=script&lang=js"
export * from "./Plans.vue?vue&type=script&lang=js"
import style0 from "./Plans.vue?vue&type=style&index=0&id=f61c1732&prod&lang=scss&scoped=true"
import style1 from "./Plans.vue?vue&type=style&index=1&id=f61c1732&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f61c1732",
  null
  
)

export default component.exports